import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../../shared/subscription-common.styles'

export const useStyles = createUseStyles(theme => ({
  ...commonStyles(theme),

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 550
  },

  title: {
    textAlign: 'center',
    fontSize: 32,
    [theme.media.smallMobile]: {
      fontSize: 26,
      paddingTop: 10
    },
    [theme.media.mobile]: {
      fontSize: 26,
      paddingTop: 10
    }
  },

  copy: {
    textAlign: 'center',
    paddingLeft: 10,
    paddingRight: 10
  },

  red: {
    color: theme.error
  },

  divider: {
    width: '100%',
    height: 1,
    margin: [5, 0, 15],
    backgroundColor: theme.field
  },

  annualInfo: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.5,
    textAlign: 'justify',
    marginBottom: 20,
    [theme.media.mobile]: {
      padding: [0, 10]
    },
    [theme.media.smallMobile]: {
      padding: [0, 10]
    }
  },

  upgradeCopy: {
    textAlign: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: -30
  },

  upgradeInfo: {
    color: theme.neonPrimary
  }
}))
